<template>
  <div class="card-box">
    <el-col
      :span="colLength"
      v-for="(item, index) in cardDataList"
      :key="index"
      class="card"
      :style="[item.style]"
    >
      <el-card
        :body-style="item.bodyStyle"
        :shadow="item.shadow"
      >
        <div
          slot="header"
          style="padding: 0;"
          v-if="item.showHeader"
        >
          <span>{{ item.headerTitle }}</span>
          <el-button
            style="float: right; padding: 3px 0"
            type="text"
            @click="item.btnClick(item, index)"
          >{{ item.btnName }}</el-button>
        </div>
        <div
          class="data-title"
          v-if="item.title"
          :style="[item.titlStyle]"
        >
          {{ item.title }}
        </div>
        <div
          class="data-list"
          v-for="(value, index) in item.dataList"
          :key="index"
          :style="[value.style]"
        >
          <div
            class="data-style"
            v-if="!value.comType"
            @click="value.click && value.click(value, item, scope && scope.row)"
          >
            <span :style="[value.labelStyle]"> {{ value.label }}： </span>
            <span
              :style="[value.dataStyle]"
              v-if="!dataArray"
            >
              {{ formatter(value.data, value, item) }}
            </span>
            <span
              v-else
              v-for="(val, idx) in formatter(value.data, value, item)"
              :key="idx"
              :style="[val.style]"
            >
              {{ val.val }}
            </span>
          </div>
          <component
            v-else
            :is="value.comType"
            :scope="scope"
            :tableData="value"
            v-bind="value"
            v-on="$listeners"
          ></component>
        </div>
      </el-card>
    </el-col>
  </div>
</template>

<script>
import popoverText from '@/components/tools/popoverText.vue'
import account from '@/components/iglobalwin/dataList/account/index.js'
import custInfo from '@/components/iglobalwin/dataList/account/custInfo.vue'
export default {
  props: {
    scope: Object,
    tableData: [Object, Array],
    cardList: Array,
  },
  data() {
    return {
      dataArray: false,
    }
  },
  computed: {
    cardDataList() {
      let { tableData, cardList } = this
      if (cardList) {
        return cardList
      } else if (tableData && tableData.cardList) {
        return tableData.cardList
      } else {
        return []
      }
    },
    colLength() {
      let length = this.cardDataList.length
      return Math.floor(24 / length)
    },
  },
  methods: {
    formatter(data, val, item) {
      let { scope, tableData } = this
      if (val.bind && val.bind != '-') {
        data = (this.scope && this.scope.row[val.bind]) || '-'
      }
      if (val.formatter) {
        if (typeof val.formatter(data, val, item, scope, tableData) == Array) {
          this.dataArray = true
        } else {
          this.dataArray = false
        }
        return val.formatter(data, val, item)
      } else {
        this.dataArray = false
        return data
      }
    },
  },
  components: {
    ...account,
    popoverText,
    custInfo,
  },
}
</script>

<style lang="scss" scoped>
.card-box {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.card {
  flex: 1;
  display: block;
  padding-right: 4px;
  line-height: 1.5em;
  cursor: pointer;
}
.card:last-child {
  padding-right: 0 !important;
}
.data-list {
  margin: 5px 0;
  .data-style {
    // 单行溢出
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.data-title {
  font-size: 20px;
  margin-bottom: 16px;
  font-weight: bold;
}
</style>
